import CacheObject from './CacheObject';

/**
 * Tries to fetch data from the client side cache.
 * @param {string} text - The text to search
 * @param {string} targetLocale - The target language to translate the text
 * @returns {object} The translation response fot that pair of text + target locale if exists in the cache. Null otherwise
 */
const get = ({ text, targetLocale }) => {
    const cacheObject = new CacheObject();
    const cacheKey = getCacheKey(targetLocale, text);

    return cacheObject.get(cacheKey);
};

/**
 * Sets data at the client side cache, using the browser localStorage as such.
 * Key is in the form of 'targetLocale/text'
 * Returns a promise that resolves with the input data once the cache is set.
 * @param {string} text - The original input text which was translated
 * @param {string} targetLocale - The locale which was the text was translated into
 * @param {object} data - The data to store, contains the translation response
 */
const set = ({ text, targetLocale, data }) => {
    const cacheKey = getCacheKey(targetLocale, text);
    const cacheObject = new CacheObject();
    cacheObject.set(cacheKey, data);
    return data;
};

const getCacheKey = (targetLocale, text) => `${targetLocale}/${text}`;

export {
    get,
    set,
    getCacheKey
};
